import * as React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PonderaModal } from '../../inclinationmodals';
import './PVAContainer.css';

interface PVAContainerProps {
    id: string;
    topic?: string;
    title: string;
    open?: boolean;
    offset?: boolean;
    clickableHeader?: boolean;
    disableAccordion?: boolean;
    tooltipOnTitle?: boolean;
    tooltipData?: {
        topic: string;
        title: string;
        content: string;
    };
    onClickHeader?: (e: React.MouseEvent<any>) => void;
    children?: React.ReactNode;
    preventInteraction?: boolean;
}

export class PVAContainerIcon extends React.Component {
    public render() {
        return this.props.children;
    }
}

export class PVAContainer extends React.Component<PVAContainerProps, { open: boolean, offset?: boolean, showTooltipModal: boolean }> {
    public static Icon = PVAContainerIcon;

    constructor(props: PVAContainerProps) {
        super(props);

        var isOpen = false;
        if (props.open == null) {// or undefined
            isOpen = true;
        } else {
            isOpen = props.open;
        }
        
        this.state = {
            open: isOpen,
            offset: props.offset,
            showTooltipModal: false,
        };
    }

    render() {
        let { disableAccordion, children } = this.props;
        disableAccordion = disableAccordion || this.props.preventInteraction;
        const { open } = this.state;

        let iconElement: React.ReactNode = null;
        const otherChildren: React.ReactNode[] = [];

        React.Children.forEach(children, (child) => {
            if (React.isValidElement(child) && (child.type === PVAContainerIcon || child.type === PVAContainer.Icon)) {
                iconElement = child;
            } else {
                otherChildren.push(child);
            }
        });

        return (
            <div id={this.props.id} className={"component-PVAContainer" + (disableAccordion ? " accordion-disabled" : "") + (open ? " open" : " closed")}>
                <div className="pva-accordion">
                    <div className="header" onClick={(e) => { 
                        if (this.props.onClickHeader) {
                            this.props.onClickHeader(e);
                        }
                        if (!disableAccordion) { 
                            this.setState({ open: !this.state.open }); 
                        } 
                    }}>
                        <div className="info">
                            {iconElement}
                            <div className="text">
                                {this.props.topic && <div className="topic">
                                    {this.props.topic}
                                </div>}
                                <div className={"title font-heading" + (this.props.onClickHeader ? " cursor-pointer" : "")}>
                                    {this.props.tooltipData && this.props.tooltipData.content && this.props.tooltipOnTitle ? (
                                        <OverlayTrigger
                                            animation={false}
                                            trigger={['hover', 'focus']}
                                            delay={0}
                                            placement="top"
                                            overlay={
                                                <Tooltip id={`tooltip-title-${this.props.id}`}>
                                                    <div dangerouslySetInnerHTML={{ __html: this.props.tooltipData.content }} />
                                                </Tooltip>
                                            }
                                        >
                                            <span className="cursor-pointer">{this.props.title}</span>
                                        </OverlayTrigger>
                                    ) : (
                                        this.props.title
                                    )}
                                </div>
                            </div>
                            {this.props.tooltipData && this.props.tooltipData.content && !this.props.tooltipOnTitle && (
                                <div
                                    className="info-icon-container"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.setState({ showTooltipModal: true });
                                    }}
                                >
                                    <img src="/images/inf tooltip.svg" />
                                </div>
                            )}
                        </div>
                        {!disableAccordion && (
                            <span className="glyphicon glyphicon-triangle-bottom chevron" />
                        )}
                    </div>
                </div>
                <div className="content">
                    {otherChildren}
                </div>
                {this.props.tooltipData && (
                    <PonderaModal
                        show={this.state.showTooltipModal}
                        onHide={() => this.setState({ showTooltipModal: false })}
                        topic={this.props.tooltipData.topic}
                        title={this.props.tooltipData.title}
                        content={this.props.tooltipData.content}
                    />
                )}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVAContainer.tsx